import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageClass } from '../helpers/local-storage-helper';

export function jwtInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  if (request.headers.has('excludeJwt')) {
    const headers = request.headers.delete('excludeJwt');
    const cleanRequest = request.clone({ headers });
    return next(cleanRequest);
  }

  const token = LocalStorageClass.retrieveTokenFromStorage();

  const requestWithJwt = request.clone({
    setHeaders: {
      Authorization: `${token}`,
      accept: 'application / vnd.api + json',
    },
  });

  return next(requestWithJwt);
}
